import { CdnService } from './../../../services/cdn.service';
import { IFeed, IAction } from "./models/IFeed";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoaderService } from "../../services/loader.service";
import * as moment from "moment";
import { ProfileService } from "../../services/profile.service";
import { CalendarService } from "../../services/calendar.service";
import { NotificationServices } from "../../services/notification.service";
import { Router } from "@angular/router";
import { EventsAttendanceService } from "../../services/events-attendance.service";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import { CertificateService } from "../../services/certificate.service";
import { RoleServiceFactoryService } from "../../services/role-service-factory.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import swal from "sweetalert2";
// const cheerio = require('cheerio');
@Component({
  selector: "app-feed-widget",
  templateUrl: "./feed-widget.component.html",
  styleUrls: ["./feed-widget.component.scss"],
})
export class FeedWidgetComponent implements OnInit {
  @Input() feed: IFeed = null;
  @Input() isPreview = false;
  @Output() onAction = new EventEmitter<IAction>();

  role = this.profileService.profile.role;
  postedBy$: Observable<string>
  isRsvp = false;
  settings: any = null;
  m = moment;
  eventStartTime = true;
  eventEndTime = true;
  isRsvpSelected = false;
  safeCalendarContent!: SafeHtml;
  hasEventRSVPOption = false;
  hasEventExpired = false;

  constructor(
    private loaderService: LoaderService,
    private profileService: ProfileService,
    private calendarServices: CalendarService,
    private notificationServices: NotificationServices,
    private router: Router,
    private eventService: EventsAttendanceService,
    private toastr: ToastrService,
    private certificateServices: CertificateService,
    public rs: RoleServiceFactoryService,
    public cndService: CdnService,
    private sanitizer: DomSanitizer
  ) { }

  basePath = "";
  allDay: boolean = false;

  ngOnInit(): void {
    if (this.feed.type == "calendar") {
      this.feed.startDay = this.feed.extraData?.startTime;
      this.feed.endDay = this.feed.extraData?.endTime;
      this.feed.title = this.feed.name;
      this.feed.allDay = this.feed.extraData?.allDay;
      this.feed.startTimeString = this.feed.extraData.startTime?.toString();
      this.feed.endTimeString = this.feed.extraData.endTime?.toString();
      this.safeCalendarContent = this.sanitizer.bypassSecurityTrustHtml(
        this.feed.extraData.content
      );
      this.isRsvpSelected = this.feed.extraData?.isRsvpSelected;
      this.hasEventRSVPOption = this.feed.extraData.isRsvpOnly;
      const eventEnded = moment().isAfter(moment(this.feed.extraData?.endTime));
      if (eventEnded) {
        // Event has ended
        this.hasEventExpired = true;
      }

      this.checkAllDay();
      this.certificateServices.getThumbnails().subscribe((settings) => {
        this.settings = settings;
        this.basePath = `https://${settings.s3PublicRepository}.s3.us-west-2.amazonaws.com/`
      });
      this.eventService
        .getAttendanceStatusById(
          this.feed.id,
          this.profileService.identity.userIdRole
        )
        .subscribe((response) => {
          if (response.rsvp) {
            this.isRsvp = true;
          }

        });
      var by = this.feed.staffId || this.feed.extraData.staffId;
      /*if(this.feed.staffId){
        this.profileService.getProfileById(this.feed.staffId).subscribe((profile)=>{
          var fullname = `${profile.lastName}, ${profile.firstName}`
          this.postedBy$ = of(fullname);
        })
      }else{
          this.postedBy$ = of('N/A')
      }*/

    }
    if (this.feed.type == "Event") {
      this.feed.startTimeString = moment(this.feed.startDateTime.time?.toString()).format('hh:mm A');
      this.feed.endTimeString = moment(this.feed.endDateTime.time?.toString()).format('hh:mm A');
      if (this.feed.startTimeString === '12:00 AM' || this.feed.startTimeString === '12:00 PM') {
        this.eventStartTime = false;
      }
      if (this.feed.endTimeString === '12:00 AM' || this.feed.endTimeString === '12:00 PM') {
        this.eventEndTime = false;
      }
    }
  }

  checkAllDay() {
    if (this.feed.startDay == this.feed.endDay) {
      this.allDay = true;
    } else {
      this.allDay = false;
    }
  }

  getFallback(ev) {
    if (ev.eventType == 'district') {
      return "./assets/img/fallbacks/lausd_news_fallback.jpg"
    } else {
      return "./assets/img/fallbacks/school_news_fallback.jpg"
    }
  }



  hasImg(content: string) {
    if (content == null) return false;
    return content.indexOf("img") >= 0;
  }

  visit(feed: IFeed) {
    let action: IAction = {
      target: feed,
      command: "visit",
    };
    this.onAction.emit(action);
  }

  goToArticle(url: string) {
    window.open(url, "_blank");
  }

  calendarAddEvent(feed: any) {
    let userType = this.profileService.profile.role;

    let startDate = moment(feed.startDay).format("YYYY-MM-DD");
    let endDate = moment(feed.endDay).format("YYYY-MM-DD");
    this.loaderService.setHttpProgressStatus(true);
    this.calendarServices
      .createEvent(
        feed.title,
        startDate + " " + feed.startTimeString,
        endDate + " " + feed.endTimeString,
        this.profileService.identity.userIdRole
      )
      .subscribe(
        (res) => {
          this.loaderService.setHttpProgressStatus(false);
          this.notificationServices.showSuccessToast(
            `New Reminder/Event has been added successfully.`
          );
          // this.router.navigate([`/${userType.toLocaleLowerCase()}/calendar`]);
        },
        (error) => {
          this.notificationServices.showInfoToast(error);
        }
      );
  }

  loadImg(desc) {
    //  let cheerio$: any = cheerio.load(desc);
    //  let url = cheerio$('p').find('img:eq(0)').attr('src');
    //  if(url == undefined){
    //   url = './assets/img/preloader/preloader.full.png';
    //  }
    //  return url;
  }

  getText(desc) {
    let text = "";
    try {
      // let cheerio1$: any = cheerio.load(desc);
      // text = cheerio1$.text();
    } catch (error) { }
    return text;
  }

  rsvp(feed) {

    swal.fire({
      title: `<strong v3-translate><span v3-translate>RSVP to event?</span> <hr/></strong>`,
      html: `<div v3-translate style="text-align:center;">
        <span v3-translate>
          Your name will be added to the list of people who will join this meeting.
        </span>
      </div>`,

      backdrop: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,

      cancelButtonText: `
      <div
        class="btn btn-warning"
        style="background-color: #FF4D00 !important; color:white;"
        v3-translate>
        Cancel
      </div>
    `,

      cancelButtonAriaLabel: "Cancel",

      confirmButtonText: `
      <div
        class="btn btn-primary"
        style="background-color: #0089FF !important;"
        v3-translate>
        Yes, Confirm
      </div>
    `,

      confirmButtonAriaLabel: "Yes, Confirm",

      reverseButtons: true,

      customClass: {
        popup: "bus-alert-popup",
        cancelButton: "no-bg-cancel",
        confirmButton: "yes-confirm-btn"
      },

      buttonsStyling: false

    }).then((willAcknowledge) => {

      if (willAcknowledge.isConfirmed) {

        const userId = this.profileService.identity.userIdRole;
        const eventId = feed.id;

        const req = {
          attendeeId: userId,
          channel: "Web",
          role: this.role
        };

        this.eventService.checkinEvent(eventId, req).subscribe(

          (res) => {
            console.log("RSVP response:", res);

            if (res.rsvp) {
              this.isRsvp = true;

              this.toastr.success(
                `Successfully RSVP'd to the ${feed.title} event and added to your calendar!`
              );

            } else if (res.hasError) {

              this.toastr.warning(
                res.errorMessage || "Could not RSVP. Try again."
              );

            } else {

              // In case backend successfully saves RSVP
              // but does not return rsvp=true
              this.isRsvp = true;

              this.toastr.success(
                `Successfully RSVP'd to the ${feed.title} event!`
              );
            }
          },

          (error) => {
            console.error("RSVP error:", error);

            this.toastr.warning(
              "Could not RSVP. Try again."
            );
          }

        );
      }
    });

    const confirmBtn = swal.getConfirmButton();

    if (confirmBtn) {
      confirmBtn.style.background = "none";
      confirmBtn.style.borderWidth = "0px";
      confirmBtn.style.border = "none";
    }

    const cancelBtn = swal.getCancelButton();

    if (cancelBtn) {
      cancelBtn.style.background = "none";
      cancelBtn.style.borderWidth = "0px";
      cancelBtn.style.border = "none";
    }
  }

  viewEventDetails(feed) {
    let userType = this.profileService.profile.role;
    if (
      userType == "Administrator" ||
      userType == "Teacher" ||
      userType == "Counselor"
    ) {
      // this.router.navigate([userType.toLocaleLowerCase(), 'events', feed.id])
      this.router.navigate([
        userType.toLocaleLowerCase(),
        "events",
        "id",
        feed.id,
      ]);
    } else {
      this.router.navigate([
        userType.toLocaleLowerCase(),
        "events",
        "id",
        feed.id,
      ]);
    }
  }

  getHtml(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
